/**
 * @description Push notification routing configuration alphabetically mapped by __typename.
 * @exports
 */
export const ROUTING = {
  appointment: '/activity',
  'appointment-book': '/consultation/counselor/request/view',
  'appointment-book-request': '/activity',
  'appointment-chat': '/consultation/appointment/chat/:queue_id',
  article: '/article/view',
  'asa-age-progress-not-eligible': '/tabs/home',
  'asa-x': '/asa-x',
  'avatar-completed': '/tabs/home',
  'avatar-failed': '/avatar/create',
  'daily-journal': '/daily/journal',
  'dna-report': '/activity',
  ehr_mcu: '/ehr/:url',
  'health-tracker-alert': '/tabs/assistant',
  'health-tracker-predictive': '/tabs/assistant',
  'health-tracker-reminder': '/tabs/home',
  'lab-sample': '/lab/:tracking_id',
  'media-music': '/media-library',
  'media-podcast': '/media-library',
  'nutrigenetic-plus': '/report/nourish/recalculate/success',
  order: '/order/:id',
  'pickup-kit-delivery': '/delivery/:id',
  'reminder-order-shipment-form': '/tabs/order/shipping',
  'reminder-submit-questionnaire-nourish': '/tabs/home',
  'reminder-submit-questionnaire-ten-x': '/tabs/home',
  shop: '/shop',
  'shop-product': '/shop',
  'virtual-assistant': '/tabs/assistant',
  'wearable-health-status': '/tabs/home'
};
